var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentProduct)?_c('CwTextBildModule',{attrs:{"id":_vm.id,"lang":_vm.lang,"country":_vm.country,"forceBackground":_vm.forceBackground,"instance":_vm.textBildInstance}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }